module.exports = __webpack_public_path__ + "img/qd-img-14.62397b26.png";